import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function ProductDevelopmentAndAnalyticalSolutions() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Product Development & Analytical Solutions', 'Product Development & Analytical Solutions']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Product Development & Analytical Solutions
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300  flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Product Development & Analytical Solutions
          </h3>
        </div>

        <p className="text-sm text-[#05326D] mb-4 font-bold">
          Comprehensive Support Across the Pharmaceutical Lifecycle
        </p>

        <p className="mb-6 text-[#05326D]">
          At FDAC Consultancy, we offer a full-spectrum suite of services that empower pharmaceutical, biotech, and life sciences organizations to accelerate innovation, ensure regulatory compliance, and expand globally. Our integrated approach spans formulation and API development, analytical validation, clinical trials, bioequivalence studies, pharmacovigilance, and business development—delivered through strategic partnerships and state-of-the-art infrastructure.
        </p>

        <hr className="border-t border-gray-300 my-8" />

        {/* Section 1: Product Development */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            1. Product Development
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">End-to-end development of APIs, excipients, and finished dosage forms</p>
        <p className="ml-2 mt-2 text-[#05326D]">Support for NDA, ANDA, 505(b)(1), 505(b)(2), and global submissions</p>
        <p className="ml-2 mt-2 text-[#05326D]">Expertise in complex formulations including hormones, elemental drugs, and locally administered products</p>
        <p className="ml-2 mt-2 text-[#05326D]">Technology transfer and dossier preparation for regulated markets (US, EU, Australia, Turkey, etc.)</p>


        {/* Section 2: Analytical Development */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            2. Analytical Development
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Analytical method development & validation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Impurity profiling, structure elucidation, and characterization</p>
        <p className="ml-2 mt-2 text-[#05326D]">ICH-compliant stability studies including photostability, bulk, and in-use</p>
        <p className="ml-2 mt-2 text-[#05326D]">Bioanalytical services for method development and validation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Pharmacokinetic and statistical analysis using advanced tools</p>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory documentation and eCTD-compliant submissions</p>


        {/* Section 3: Clinical Trials */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            3. Clinical Trials & Bioequivalence Studies
          </span>
        </div>
        {/* <h3 className="text-lg font-bold text-[#05326D] mb-3">3. Clinical Trials & Bioequivalence Studies</h3> */}
        <p className="mb-4 ml-2 mt-2 text-[#05326D]">
          <strong>From Concept to Global Submission</strong><br />
          FDAC provides tailored solutions for clinical trials and bioequivalence studies, ensuring scientific rigor, regulatory alignment, and operational excellence.
        </p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Study Types Supported:
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">BA/BE Studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Healthy Volunteer & Patient-Based Trials</p>
        <p className="ml-2 mt-2 text-[#05326D]">Early & Late Phase Clinical Trials</p>
        <p className="ml-2 mt-2 text-[#05326D]">Special Studies: Inhalation, Suppository, Glucose Clamp</p>
        <p className="ml-2 mt-2 text-[#05326D]">Biosimilars & Biologicals</p>
        <p className="ml-2 mt-2 text-[#05326D]">Biopharmaceutics & Complex Drug Designs</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Our Services Include:
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">CRO & Bio Study Site Identification</p>
        <p className="ml-2 mt-2 text-[#05326D]">CRO Auditing & Study Monitoring</p>
        <p className="ml-2 mt-2 text-[#05326D]">Clinical Project Management</p>
        <p className="ml-2 mt-2 text-[#05326D]">Study Design & Strategy Development</p>
        <p className="ml-2 mt-2 text-[#05326D]">Clinical Data Management & Biostatistics</p>
        <p className="ml-2 mt-2 text-[#05326D]">Medical Writing & Safety Reporting</p>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory Support & Query Resolution</p>
        <p className="ml-2 mt-2 text-[#05326D]">Sample Retention & Archiving</p>
        <p className="ml-2 mt-2 text-[#05326D]">Compliance with GCP/GLP & Global Health Authority Guidelines</p>


        {/* Section: Infrastructure */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Infrastructure Highlights
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">200+ Beds for Clinical Trials</p>
        <p className="ml-2 mt-2 text-[#05326D]">Sample Storage at Controlled Temperatures</p>
        <p className="ml-2 mt-2 text-[#05326D]">Advanced Instruments: LC-MS/MS, ICP-OES, ICP-MS, Waters Xevo-TQS with UPLC</p>
        <p className="ml-2 mt-2 text-[#05326D]">CAP & NABL Accredited Labs</p>
        <p className="ml-2 mt-2 text-[#05326D]">US FDA & International Regulatory Approvals</p>
        <p className="ml-2 mt-2 text-[#05326D]">Volunteer Database of 20,000+ Subjects</p>
        <p className="ml-2 mt-2 text-[#05326D]">Full-service Clinical Pathology Testing (Biochemistry, Hematology, Serology)</p>


        {/* Section 4: Business Development */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            4. Business Development
          </span>
        </div>
        {/* <h3 className="text-lg font-bold text-[#05326D] mb-3">4. Business Development</h3> */}
        <p className="mb-4 text-[#05326D]">
          <strong>Strategic Growth in Regulated & Emerging Markets</strong><br />
          The generic pharmaceutical industry presents vast opportunities for collaboration, licensing, and market expansion. At NUVO, we help clients identify and capitalize on these opportunities through our global network and deep industry insight.
        </p>
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Services Offered:
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Partner Identification for Distribution & Marketing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Contract Manufacturing & Supply Chain Partnerships</p>
        <p className="ml-2 mt-2 text-[#05326D]">API & Formulation Sourcing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory Representation in the US & India</p>
        <p className="ml-2 mt-2 text-[#05326D]">Clinical Trial & BE Study Partnerships</p>
        <p className="ml-2 mt-2 text-[#05326D]">EU-Based Batch Release & Testing Coordination</p>


        <p className="text-sm mt-4 text-[#05326D]">
          FDAC is your trusted partner for scientific excellence, regulatory success, and global growth. Our multidisciplinary teams and proven infrastructure ensure that every project is executed with precision, compliance, and strategic foresight.
        </p>
      </div>
    </div>
  );
}

export default ProductDevelopmentAndAnalyticalSolutions;
